<ntap-view-window target="globalDialog"></ntap-view-window>
<ng-container *ngIf="currentViewState">
    <ng-container ntapFilterViewProvider [viewName]="currentViewName" [viewState]="currentViewStateFilter">
        <ng-container appKlasaHierarchyListViewProvider [viewName]="currentViewName" [viewState]="currentViewState">
            <ntap-dynamic [compId]="INIT_COMP_ID" [class]="currentViewClass"></ntap-dynamic>
        </ng-container>
    </ng-container>
</ng-container>